export const drawerCustomizations = {
  MuiDrawer: {
    styleOverrides: {
      paper: {
         backgroundColor: ({ theme }) => theme.palette.background.paper, // NWR blue
         color: ({ theme }) => theme.palette.text.primary,
        borderRight: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      },
    },
    defaultProps: {
      anchor: "left",
    },
  },
};
